import { useMediaQuery } from '@vueuse/core'

export const useIsMobile = () => {
  // Server-side detection using User-Agent
  if (process.server) {
    const headers = useRequestHeaders()
    const userAgent = headers['user-agent'] || ''

    // Mobile device detection regex
    const mobileRegex =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i
    return ref(mobileRegex.test(userAgent))
  }

  // Client-side detection using media query
  return useMediaQuery('(max-width: 640px)')
}
